export interface ProjectWorkbookUploadEventMap {
  '@clatter/PROJECT_WORKBOOK_UPLOAD_COMPLETED': undefined;
  '@clatter/PROJECT_WORKBOOK_UPLOAD_FAILED': undefined;
}

export class ProjectWorkbookUploadEvent<K extends keyof ProjectWorkbookUploadEventMap> extends Event {
  readonly data: { type: K; data: ProjectWorkbookUploadEventMap[K] };

  constructor(type: K, data: ProjectWorkbookUploadEventMap[K]) {
    super(type);

    this.data = { type, data };
  }
}

export const subscribe = <K extends keyof ProjectWorkbookUploadEventMap>(
  eventName: K,
  callback: (event: ProjectWorkbookUploadEvent<K>) => void,
) => {
  window.addEventListener(eventName, callback as any);

  return () => {
    window.removeEventListener(eventName, callback as any);
  };
};

export const unsubscribe = <K extends keyof ProjectWorkbookUploadEventMap>(
  eventName: K,
  callback: (event: ProjectWorkbookUploadEvent<K>) => void,
) => {
  window.removeEventListener(eventName, callback as any);
};

export const publish = <K extends keyof ProjectWorkbookUploadEventMap>(
  eventName: K,
  data: ProjectWorkbookUploadEventMap[K],
) => {
  const event = new ProjectWorkbookUploadEvent(eventName, data);

  window.dispatchEvent(event);
};

export const ProjectWorkbookUploadEventBus = {
  subscribe,
  unsubscribe,
  publish,
};
